const headRowsFreq = {
  name: 'Periodicidade',
  month: 'Intervalo'
};

export default headRowsFreq;
